/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useQuery } from "@tanstack/react-query";
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { ErrorType } from "../../apix-handler";
import type {
  BadRequestResponse,
  EntityChangeDisplayResponse,
  EntityChangeTrackingEntityChangesGetV2Params,
  EntityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2Params,
  ForbiddenResponse,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Gets entity change tracking information for a specific entity
 */
export const entityChangeTrackingEntityChangesGetV2 = (
  params?: EntityChangeTrackingEntityChangesGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<EntityChangeDisplayResponse>(
    {
      url: `/apix/v2/EntityChangeTracking/entity-changes`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getEntityChangeTrackingEntityChangesGetV2QueryKey = (
  params?: EntityChangeTrackingEntityChangesGetV2Params,
) => {
  return [
    `/apix/v2/EntityChangeTracking/entity-changes`,
    ...(params ? [params] : []),
  ] as const;
};

export const getEntityChangeTrackingEntityChangesGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof entityChangeTrackingEntityChangesGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: EntityChangeTrackingEntityChangesGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof entityChangeTrackingEntityChangesGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEntityChangeTrackingEntityChangesGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof entityChangeTrackingEntityChangesGetV2>>
  > = ({ signal }) =>
    entityChangeTrackingEntityChangesGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof entityChangeTrackingEntityChangesGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EntityChangeTrackingEntityChangesGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof entityChangeTrackingEntityChangesGetV2>>
>;
export type EntityChangeTrackingEntityChangesGetV2QueryError =
  ErrorType<unknown>;

/**
 * @summary Gets entity change tracking information for a specific entity
 */

export function useEntityChangeTrackingEntityChangesGetV2<
  TData = Awaited<ReturnType<typeof entityChangeTrackingEntityChangesGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: EntityChangeTrackingEntityChangesGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof entityChangeTrackingEntityChangesGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEntityChangeTrackingEntityChangesGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Stability Level**: `draft`
 * @summary Gets entity change tracking information for an entity accessed via share token (external access).
The entity, builder, and job are resolved server-side from the token; clients cannot supply
entity identifiers directly.
 */
export const entityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2 =
  (
    entityShareToken: string,
    params?: EntityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2Params,
    options?: SecondParameter<typeof apixHandler>,
    signal?: AbortSignal,
  ) => {
    return apixHandler<EntityChangeDisplayResponse>(
      {
        url: `/apix/v2/EntityChangeTracking/external/${entityShareToken}/entity-changes`,
        method: "GET",
        params,
        signal,
      },
      options,
    );
  };

export const getEntityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2QueryKey =
  (
    entityShareToken?: string,
    params?: EntityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2Params,
  ) => {
    return [
      `/apix/v2/EntityChangeTracking/external/${entityShareToken}/entity-changes`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getEntityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof entityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2
      >
    >,
    TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  >(
    entityShareToken: string,
    params?: EntityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2Params,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof entityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2
          >
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getEntityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2QueryKey(
        entityShareToken,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof entityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2
        >
      >
    > = ({ signal }) =>
      entityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2(
        entityShareToken,
        params,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!entityShareToken,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof entityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type EntityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof entityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2
      >
    >
  >;
export type EntityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2QueryError =
  ErrorType<BadRequestResponse | ForbiddenResponse>;

/**
 * @summary Gets entity change tracking information for an entity accessed via share token (external access).
The entity, builder, and job are resolved server-side from the token; clients cannot supply
entity identifiers directly.
 */

export function useEntityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2<
  TData = Awaited<
    ReturnType<
      typeof entityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2
    >
  >,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  entityShareToken: string,
  params?: EntityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          typeof entityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2
        >
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getEntityChangeTrackingExternalEntityChangesByEntityShareTokenGetV2QueryOptions(
      entityShareToken,
      params,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
